import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'http://154.61.173.117:5001',
  // timeout: 10000, // 10 seconds timeout
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`; //This will sent token for each request
  }
  return config;
});

export default axiosInstance;
